import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavController } from 'ionic-angular';
import { MessengerProvider } from '../../providers/messenger/messenger';
import { GlobalNotificationsProvider } from '../../providers/global-notifications/global-notifications';
import { query } from '@angular/core/src/animation/dsl';
import { MessagesAll, DataEntity } from './../../models/meesages.model';

/**
 * Generated class for the MessengerMessagesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'messenger-messages',
  templateUrl: 'messenger-messages.html',
})
export class MessengerMessagesComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input('search') search: string = '';
  @Input('refresh') refresh;
  @Output() changeSegment: EventEmitter<string> = new EventEmitter<string>();
  messages: DataEntity[];
  notifications: any;
  page = 0;
  pageSize = 7;
  totalPages: number = 0;

  private _newMessages: boolean;
  get newMessages(): boolean {
    return this._newMessages;
  }
  set newMessages(newMessages: boolean) {
    this._newMessages = newMessages;
    if (newMessages) {
      this.page = 0;
      this.loadMessages();
    }
  }

  constructor(
    private navCtrl: NavController,
    private messengerProvider: MessengerProvider,
    private globalNotifications: GlobalNotificationsProvider
  ) {}

  ngOnInit(): void {
    this.loadMessages();
    this.notifications = this.globalNotifications.newMessage.subscribe(
      message => (this.newMessages = message)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['refresh'] !== undefined || changes['search'] !== undefined) {
      this.page = 0;
      this.loadMessages(this.search);
    }
  }

  ngOnDestroy(): void {
    this.notifications.unsubscribe();
  }

  loadMessages(query?: string): void {
    // this.messengerProvider.getAllMessages().subscribe((response: any) => {
    //   this.messages = Object.values(response.data).sort((a: any, b: any) => {
    //     return b.messages[0].cdate - a.messages[0].cdate;
    //   });

    //   //this.globalNotifications.retrieveNewMessages().subscribe();
    //   console.log(this.messages);
    // });
    this.messengerProvider
      .getAllSearch(this.search, this.page, this.pageSize)
      .subscribe((res: MessagesAll) => {
        this.messages = res.data;
        this.totalPages = res.totalPages;
        this.globalNotifications.retrieveNewMessages().subscribe();
      });
  }

  viewMessages(userId: string): void {
    console.log(userId);
    this.navCtrl.push('MessagePage', {
      userId: userId,
    });
  }

  doInfinite(infiniteScroll) {
    if (this.totalPages > this.page) {
      this.page++;
    }
    setTimeout(() => {
      this.messengerProvider
        .getAllSearch(this.search, this.page, this.pageSize)
        .subscribe(res => {
          const data = res.data;
          this.totalPages = res.totalPages;
          for (let index = 0; index < data.length; index++) {
            this.messages.push(data[index]);
          }
        });
      infiniteScroll.complete();
    }, 1000);
  }

  goToContacts(): void {
    this.changeSegment.emit('contacts');
  }
}



// WEBPACK FOOTER //
// ./src/components/messenger-messages/messenger-messages.ts